export default "__VITE_ASSET__C_Amb0H___"